import { useCallback } from 'react';

import { store, useAppDispatch, useAppSelector } from '~/modules/store';
import { removeStepsFromCurrentTest, updateCurrentTestQuery } from '~/modules/tests/tests.api';
import { selectCurrentTestId } from '~/modules/tests/tests.selectors';

import { StepsActions } from '../../steps.redux';
import { selectTemporaryStep } from '../../steps.selectors';

export const useRemoveTemporaryStep = () => {
  const dispatch = useAppDispatch();
  const currentTestId = useAppSelector(selectCurrentTestId);
  const temporaryStep = useAppSelector(selectTemporaryStep);

  return useCallback(() => {
    if (!currentTestId || !temporaryStep) return;

    updateCurrentTestQuery(store.getState, dispatch, (draft) => {
      removeStepsFromCurrentTest(draft, { ids: [temporaryStep.id] });
    });
    dispatch(StepsActions.resetCurrentStep());
  }, [currentTestId, dispatch, temporaryStep]);
};
